package com.vamvisions.main.components

import androidx.compose.runtime.Composable
import com.vamvisions.main.theme.AppStyleSheet
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

/** A small filled label on a card, such as "Coming soon". CSS sets it in capitals, so [label] stays in normal case. */
@Composable
fun StatusBadge(label: String) {
    Span(attrs = { classes(AppStyleSheet.statusBadge) }) { Text(label) }
}
